import React, {
  Fragment,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
// Row/Col removed - now using MUI Box grid
// styled removed - no longer using styled-components
// FormControlLabel removed - using custom MUI layout
import { useAsync } from "../../../../../../hooks";
import { KhungNoiDungsEndpoint } from "../../../../../../service/Meet";
import NoiDungVanDe from "../../NoiDung";
// formDataTTPH removed - using inline data display
import DangKyPhatBieu from "../../DangKyPhatBieu";
import FormAttachFile from "../../FormAttachFile";
import Pending from "../../Component/Pending";
import ReloadService from "../../../../../../service/Reload.service";
import { TypeEnums } from "../../reloadConstants";
import useSSEReload from "../../useSSEReload";
import {
  CHECK_ERROR,
  CHECK_SUCCESS,
  CHECK_TIME,
  CHECK_WARNING,
} from "../../../../../../components/alert/Alert";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Radio,
  RadioGroup,
  Typography,
  Box,
  Icon,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { _Enum_Trang_Thai_Noi_Dung } from "../../../../../action/defaultEnums";
import { TOKEN_CLIENT_INFO } from "../../../../../../actions/constants";
// import { getTimeDeadLine } from "../../../../../../actions/util";
import { forwardRef } from "react";
import useUnload from "../../../../../../hooks/useUnload";
import "../style.scss";
import { useSelector, useDispatch } from "react-redux";
import { actionGRPC, actionNoiDung } from "../../../Redux/ActionsMeeting";
// ButtonReset removed - using MUI Button instead

// Fieldset removed - using MUI Box for both Info and Document sections

const Enum_Proto_VanDe = [
  TypeEnums.VANDE,
  TypeEnums.KETQUA,
  TypeEnums.VANDEHOANTHANH,
  TypeEnums.VANDEFULL,
  TypeEnums.XOAVANDE,
  TypeEnums.LAMMOI,
];
const Enum_Proto_PhatBieu = [
  TypeEnums.DUNGPHATBIEU,
  TypeEnums.PHATBIEU,
  TypeEnums.CHIDINHPHATBIEU,
  TypeEnums.GHIAMPHATBIEU,
  TypeEnums.XOAPHATBIEU,
];
/**
 * 0. Chuyển sang nội dung mới
 * 1. Khi patch bổ sung vấn đề từ trạng thái mới thành hoạt động
 * 2. Khi cán bộ tham gia phiên họp patch phương án bổ sung thì bên chủ trì load lại
 * 3. Khi chủ trì patch bố sung vấn đề thành hoàn thành
 * 4. Có cán bộ đăng ký phát biểu
 * 5. Khi người chuyên viên tạo vấn đề mới
 * 6. Kết thúc phiên họp
 * 7. Có cán bộ thoát hoặc tham gia phiên họp
 * 8. Cán bộ đươc chỉ định phát biểu
 * 9. Thư ký bật ghi âm phát biểu của 1 cán bộ
 * 10.Ông chủ trì/Thư ký xóa phát biểu mà họ chỉ định hoặc cán bộ tự xóa phát biểu đã đăng ký
 * 11.
 * 12.Xóa vấn đề biểu quyết(thư ký hoặc chuyên viên mới có thể xóa)
 */
const Info = React.memo(
  ({
    data,
    title,
    statusNoiDung,
    isChuTri,
    isDienBien,
    khungNoiDungs,
    khungNoiDungId,
    onSelectNoiDung,
  }) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogStep, setDialogStep] = useState("choose"); // "choose" | "select"
    const [selectedNoiDung, setSelectedNoiDung] = useState(null);

    const donViChuanBi = useMemo(() => {
      const donVis = data?.khungNoiDungOrganizations?.reduce((acc, item) => {
        if (item.isChuTri) {
          acc.push(item.organization);
        }
        return acc;
      }, []);
      return donVis;
    }, [data]);

    // Lấy danh sách tất cả nội dung có thể chọn (trừ nội dung hiện tại)
    const selectableNoiDungs = useMemo(() => {
      if (!khungNoiDungs || !khungNoiDungId) return [];
      // Lọc bỏ nội dung hiện tại, giữ lại tất cả nội dung khác
      return khungNoiDungs.filter((nd) => nd.id !== khungNoiDungId);
    }, [khungNoiDungs, khungNoiDungId]);

    // Lấy nội dung tiếp theo theo thứ tự (nội dung ngay sau nội dung hiện tại)
    const nextNoiDung = useMemo(() => {
      if (!khungNoiDungs || !khungNoiDungId) return null;
      const currentIndex = khungNoiDungs.findIndex(
        (nd) => nd.id === khungNoiDungId,
      );
      if (currentIndex === -1 || currentIndex >= khungNoiDungs.length - 1)
        return null;
      return khungNoiDungs[currentIndex + 1];
    }, [khungNoiDungs, khungNoiDungId]);

    const handleOpenDialog = () => {
      setOpenDialog(true);
      setDialogStep("choose");
      setSelectedNoiDung(null);
    };

    const handleCloseDialog = () => {
      setOpenDialog(false);
      setDialogStep("choose");
      setSelectedNoiDung(null);
    };

    const handleChooseNext = () => {
      handleCloseDialog();
      // Truyền nội dung tiếp theo theo thứ tự
      onSelectNoiDung(nextNoiDung);
    };

    const handleChooseSelect = () => {
      setDialogStep("select");
    };

    const handleConfirmSelect = () => {
      if (selectedNoiDung) {
        handleCloseDialog();
        onSelectNoiDung(selectedNoiDung);
      }
    };

    return (
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #e5e7eb",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            padding: "12px 16px",
            borderBottom: "1px solid #e5e7eb",
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: "6px",
              backgroundColor: "#dcfce7",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography sx={{ fontSize: "14px" }}>📋</Typography>
          </Box>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#374151",
            }}
          >
            {title}
          </Typography>
        </Box>

        {/* Content */}
        <Box
          sx={{
            flex: 1,
            padding: "12px 16px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
          className="start-meet"
        >
          <Pending loading={statusNoiDung === "pending" || !data} numberRow={4}>
            {/* Layout matching reference design exactly */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
              {/* Row 1: Badge + Time + Action Button */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  {/* Mục Badge */}
                  <Box
                    sx={{
                      backgroundColor: "#eff6ff",
                      color: "#3b82f6",
                      fontSize: "12px",
                      fontWeight: 600,
                      padding: "4px 12px",
                      borderRadius: "16px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Mục{" "}
                    {String(
                      khungNoiDungs?.findIndex(
                        (nd) => nd.id === khungNoiDungId,
                      ) + 1 || 1,
                    ).padStart(2, "0")}
                  </Box>

                  {/* Duration Badge - matching Vertical.jsx logic */}
                  <Box
                    sx={{
                      fontSize: "11px",
                      fontWeight: 500,
                      backgroundColor: "white",
                      color: "#4b5563",
                      padding: "2px 8px",
                      borderRadius: "4px",
                      display: "inline-block",
                    }}
                  >
                    {data?.thoiLuong
                      ? `${data.thoiLuong} phút`
                      : "Dự tính 15 phút"}
                  </Box>

                  {/* Đang trình bày badge */}
                  {data?.trangThai === _Enum_Trang_Thai_Noi_Dung.DangHop && (
                    <Box
                      sx={{
                        fontSize: "11px",
                        fontWeight: 500,
                        backgroundColor: "#dbeafe",
                        color: "#1d4ed8",
                        padding: "2px 8px",
                        borderRadius: "4px",
                        display: "inline-block",
                      }}
                    >
                      Đang trình bày
                    </Box>
                  )}
                </Box>
              </Box>

              {/* Row 2: Title */}
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 700,
                  color: "#1f2937",
                  lineHeight: 1.4,
                }}
              >
                {data?.noiDung || "Nội dung"}
              </Typography>

              {/* Row 3: Presenter Card */}
              {(data?.nguoiTrinhBay || donViChuanBi?.length > 0) && (
                <Box
                  sx={{
                    backgroundColor: "#f8fafc",
                    borderRadius: "12px",
                    padding: "16px",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  {/* Avatar */}
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: "50%",
                      backgroundColor: "#e5e7eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Typography sx={{ fontSize: "20px", color: "#6b7280" }}>
                      👤
                    </Typography>
                  </Box>

                  {/* Info */}
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontSize: "10px",
                        fontWeight: 600,
                        color: "#9ca3af",
                        letterSpacing: "0.5px",
                        mb: 0.5,
                      }}
                    >
                      Người trình bày
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#1f2937",
                        mb: 0.25,
                      }}
                    >
                      {data?.nguoiTrinhBay?.hoTen ||
                        donViChuanBi
                          ?.map((org) => org?.shortName || org?.organName)
                          .join(", ") ||
                        "Chưa xác định"}
                    </Typography>
                    {(data?.nguoiTrinhBay?.chucVu ||
                      data?.nguoiTrinhBay?.organization?.organName) && (
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#6b7280",
                          fontStyle: "italic",
                        }}
                      >
                        {data?.nguoiTrinhBay?.chucVu}
                        {data?.nguoiTrinhBay?.chucVu &&
                          data?.nguoiTrinhBay?.organization?.organName &&
                          " - "}
                        {data?.nguoiTrinhBay?.organization?.organName}
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}

              {/* Action Button - Chuyển nội dung (chỉ cho chủ trì) */}
              {data?.trangThai === _Enum_Trang_Thai_Noi_Dung.DangHop &&
                !isDienBien &&
                isChuTri && (
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleOpenDialog}
                    endIcon={<ArrowForwardIcon />}
                    sx={{
                      background:
                        "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                      borderRadius: "8px",
                      padding: "10px 20px",
                      fontSize: "13px",
                      fontWeight: 600,
                      textTransform: "none",
                      boxShadow: "0 2px 8px rgba(59, 130, 246, 0.3)",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                        boxShadow: "0 4px 12px rgba(59, 130, 246, 0.4)",
                      },
                      transition: "all 0.2s ease",
                    }}
                  >
                    Chuyển đến nội dung tiếp theo
                  </Button>
                )}
            </Box>
          </Pending>

          {/* Dialog chọn phương thức chuyển nội dung */}
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle
              sx={{
                background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                color: "white",
                fontWeight: 600,
              }}
            >
              {dialogStep === "choose"
                ? "Chọn phương thức chuyển nội dung"
                : "Chọn nội dung muốn chuyển đến"}
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              {dialogStep === "choose" ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    py: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleChooseNext}
                    fullWidth
                    sx={{
                      py: 1.5,
                      fontSize: "15px",
                      fontWeight: 600,
                      textTransform: "none",
                    }}
                  >
                    Chuyển đến nội dung tiếp theo
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleChooseSelect}
                    fullWidth
                    disabled={selectableNoiDungs.length === 0}
                    sx={{
                      py: 1.5,
                      fontSize: "15px",
                      fontWeight: 600,
                      textTransform: "none",
                    }}
                  >
                    Chuyển đến nội dung chỉ định
                  </Button>
                  {selectableNoiDungs.length === 0 && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ textAlign: "center" }}
                    >
                      Không còn nội dung nào khác để chọn
                    </Typography>
                  )}
                </Box>
              ) : (
                <Box sx={{ py: 1 }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    Chọn nội dung bạn muốn chuyển đến:
                  </Typography>
                  <RadioGroup
                    value={selectedNoiDung?.id || ""}
                    onChange={(e) => {
                      const selected = selectableNoiDungs.find(
                        (nd) => nd.id === e.target.value,
                      );
                      setSelectedNoiDung(selected);
                    }}
                  >
                    <List sx={{ maxHeight: 300, overflow: "auto" }}>
                      {selectableNoiDungs.map((nd, index) => (
                        <ListItem
                          key={nd.id}
                          disablePadding
                          sx={{
                            border: "1px solid #e0e0e0",
                            borderRadius: 1,
                            mb: 1,
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        >
                          <ListItemButton
                            onClick={() => setSelectedNoiDung(nd)}
                            selected={selectedNoiDung?.id === nd.id}
                          >
                            <Radio
                              checked={selectedNoiDung?.id === nd.id}
                              value={nd.id}
                              sx={{ mr: 1 }}
                            />
                            <ListItemText
                              primary={`${nd.thuTu || index + 1}. ${nd.noiDung || nd.name || "Nội dung " + (index + 1)}`}
                              primaryTypographyProps={{
                                fontWeight:
                                  selectedNoiDung?.id === nd.id ? 600 : 400,
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  </RadioGroup>
                </Box>
              )}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button onClick={handleCloseDialog} color="inherit">
                Hủy
              </Button>
              {dialogStep === "select" && (
                <Button
                  onClick={handleConfirmSelect}
                  variant="contained"
                  color="primary"
                  disabled={!selectedNoiDung}
                >
                  Xác nhận
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
    );
  },
);

const Index = forwardRef((props, ref) => {
  const {
    khungNoiDungId,
    phienHopId,
    title,
    isView,
    setActiveNextNoiDung,
    handleClose,
    isDienBien,
    updateDataThamDu,
  } = props;

  // const [dataND, setDataND] = useState(null);
  const refPhatBieu = useRef();
  const refVanDe = useRef();
  const refStream = useRef();
  const dispatch = useDispatch();
  const { isChuTri, connect, noiDung, phienHop } = useSelector(
    (state) => state.meetingRProcess,
  );
  const refFormAttachFile = useRef();
  // const state = useNetworkState();

  const getKhungNoiDung = useCallback(
    async (idNoiDung) => {
      if (idNoiDung) {
        const data = await KhungNoiDungsEndpoint.getDataDetailByID(idNoiDung);
        const { nhanSu, thanhPhanThamDus, khungNoiDungOrganizations } = data;
        // const existInContent = thanhPhanThamDus.find(
        //   (cur) => cur.nhanSuId === TOKEN_CLIENT_INFO.nhanSuId,
        // );
        const existInContent = khungNoiDungOrganizations.find(
          (cur) => cur.organizationId === TOKEN_CLIENT_INFO.organizationId,
        );
        const existInContentKhachMoi = thanhPhanThamDus.find(
          (cur) => cur.khachMoiId === TOKEN_CLIENT_INFO.khachMoiId,
        );
        const accessLayout = document.getElementById("overlay-access");
        if (!isChuTri && TOKEN_CLIENT_INFO?.mainRole !== "CV") {
          existInContent || existInContentKhachMoi
            ? (accessLayout.style.display = "none")
            : (accessLayout.style.display = "flex");
        }
        if (nhanSu) {
          const {
            thongTinCaNhan: { hoVaTenDem, ten },
            id,
          } = nhanSu;
          data["nhanSuId"] = { value: id, hoVaTen: hoVaTenDem + ` ` + ten };
          delete data["nhanSu"];
        }
        dispatch(actionNoiDung(data));
        return true;
      }
    },
    [dispatch, isChuTri],
  );

  const { status: statusNoiDung, execute: getNoiDung } =
    useAsync(getKhungNoiDung);

  useEffect(() => {
    khungNoiDungId && getNoiDung(khungNoiDungId);
  }, [getNoiDung, khungNoiDungId]);

  const endStream = useCallback(() => {
    refStream && refStream.current?.close();
  }, []);

  const createViewed = ({ meetingId, dataId, type, userId }) => ({
    meetingId,
    dataId,
    type,
    userId,
  });

  const viewedLoader = useCallback(
    (object) => {
      const { dataId, type, isnew } = object;
      const viewed = createViewed(object);
      if (Enum_Proto_VanDe.includes(type)) {
        dispatch(actionGRPC({ viewed, data: { key: dataId, type } }));
        refVanDe.current
          ?.updateReload(dataId, type)
          .then((res) => {})
          .catch((err) => CHECK_WARNING(err));
      } else if (type === TypeEnums.NOIDUNG || type === 15) {
        KhungNoiDungsEndpoint.getDataByIdPhien(phienHopId).then(({ value }) => {
          const activeNoiDung = value.find(
            (cur) => cur.trangThai === _Enum_Trang_Thai_Noi_Dung.DangHop,
          );
          activeNoiDung && setActiveNextNoiDung(activeNoiDung.id, false, value);
        });
      } else if (Enum_Proto_PhatBieu.includes(type)) {
        const formPhatBieu = refPhatBieu.current;
        formPhatBieu &&
          formPhatBieu
            .updateReload({ isnew, isChuTri, idDangKyPhatBieu: dataId, type })
            .then((res) => {})
            .catch((err) => CHECK_WARNING(err));
      } else if (type === TypeEnums.THAMDU) {
        updateDataThamDu(phienHopId)
          .then((res) => {})
          .catch((err) => CHECK_WARNING("Mất kết nối stream"));
      } else {
        if (!isDienBien) {
          CHECK_TIME(
            "Phiên họp kết thúc",
            "Quay về danh sách phiên họp",
            () => {},
          ).then(() => {
            if (typeof handleClose === "function") {
              handleClose();
            }
          });
        }
      }
    },
    [
      dispatch,
      handleClose,
      isChuTri,
      isDienBien,
      phienHopId,
      setActiveNextNoiDung,
      updateDataThamDu,
    ],
  );

  const handleSSEData = useCallback(
    (data) => {
      if (data) {
        viewedLoader(data);
      }
    },
    [viewedLoader],
  );

  const { eventSourceRef } = useSSEReload(
    !!(phienHopId && connect),
    handleSSEData,
    phienHopId,
  );
  refStream.current = eventSourceRef.current;

  useImperativeHandle(ref, () => ({ endStream }));

  useEffect(() => {
    const connectLayout = document.getElementById("overlay-connect");
    if (phienHopId && connect) {
      connectLayout.style.display = "none";
    } else {
      connectLayout.style.display = "flex";
      endStream();
    }
  }, [connect, endStream, phienHopId]);

  // Handler thống nhất để chuyển nội dung
  // - Nếu selectedNoiDung = null -> chuyển đến nội dung tiếp theo (tuần tự)
  // - Nếu selectedNoiDung có giá trị -> chuyển đến nội dung được chỉ định
  const handleSelectNoiDung = useCallback(
    async (selectedNoiDung) => {
      try {
        if (selectedNoiDung) {
          // Trường hợp 1: Chuyển đến nội dung chỉ định
          await KhungNoiDungsEndpoint.ChuyenNoiDungHop({
            khungId: khungNoiDungId,
            khungTiepTheoId: selectedNoiDung.id,
          });
          // Reload danh sách nội dung từ server để cập nhật trạng thái mới
          const { value: updatedNoiDungs } =
            await KhungNoiDungsEndpoint.getDataByIdPhienNotMap(phienHopId);
          // Gọi setActiveNextNoiDung với isNext=false để active chính nội dung được chọn
          setActiveNextNoiDung(selectedNoiDung.id, false, updatedNoiDungs);
        }
      } catch (err) {
        CHECK_ERROR("Thao tác thất bại!");
      }
    },
    [khungNoiDungId, phienHopId, setActiveNextNoiDung],
  );

  useUnload((e) => {
    e.preventDefault();
    if (refStream.current) refStream.current.close();
    e.returnValue = "";
  });

  const Document = useMemo(() => {
    return (
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #e5e7eb",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 16px",
            borderBottom: "1px solid #e5e7eb",
            flexShrink: 0,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: "6px",
                backgroundColor: "#eff6ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography sx={{ fontSize: "14px" }}>📁</Typography>
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#374151",
              }}
            >
              Tài liệu đính kèm
            </Typography>
          </Box>
          <Button
            variant="text"
            size="small"
            onClick={() => {
              refFormAttachFile.current.reload(noiDung?.fileId);
            }}
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              color: "#3b82f6",
              textTransform: "none",
              padding: "4px 8px",
              minWidth: "auto",
              "&:hover": {
                backgroundColor: "#eff6ff",
              },
            }}
          >
            🔄 Tải mới
          </Button>
        </Box>

        {/* Content */}
        <Box
          sx={{
            flex: 1,
            padding: "12px 16px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <FormAttachFile
            ref={refFormAttachFile}
            id={noiDung?.fileId}
            phienHopId={phienHopId}
            TEndpoint={KhungNoiDungsEndpoint}
            stylePDF="PDF"
            cardView
            isDownload
          />
        </Box>
      </Box>
    );
  }, [noiDung, phienHopId]);
  const renderDangKy = useMemo(
    () => (
      <DangKyPhatBieu
        dataND={noiDung}
        isDienBien={isDienBien}
        ref={refPhatBieu}
        isChuTri={isChuTri}
        isView={isView}
        khungNoiDungId={khungNoiDungId}
      />
    ),
    [isChuTri, isDienBien, isView, khungNoiDungId, noiDung],
  );

  const renderVanDe = useMemo(
    () => (
      <NoiDungVanDe
        isDienBien={isDienBien}
        ref={refVanDe}
        isChuTri={isChuTri}
        phienHopId={phienHopId}
      />
    ),
    [isChuTri, isDienBien, phienHopId],
  );

  return (
    <Fragment>
      <div
        id="overlay-connect"
        className="overlay-connecting justify-content-center align-items-center text-white h2"
      >
        <div className="text-center">
          <ErrorOutlineIcon sx={{ mr: 1 }} /> Mất kết nối
          <br />
          Đang kết nối trở lại
          <span className="progress-connect" />
        </div>
      </div>
      <div className="w-100 position-relative">
        <div
          id="overlay-access"
          className="overlay-accessing position-absolute justify-content-center align-items-center text-white h2"
        >
          <div className="text-center">
            <div>
              <Icon fontSize="large" color="warning">
                front_hand
              </Icon>
            </div>
            Bạn không có quyền truy cập nội dung này
          </div>
        </div>

        {/* Modern Content Container */}
        <Box
          sx={{
            backgroundColor: "#f8fafc",
            borderRadius: "8px",
            padding: "12px",
            height: "100%",
          }}
        >
          {/* Content Sections Grid */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
              height: "calc(70vh - 200px)",
              marginBottom: "16px",
            }}
          >
            {/* Info Section */}
            <Info
              {...{ title, statusNoiDung, isChuTri, isDienBien }}
              data={noiDung}
              title="Thông tin chung"
              khungNoiDungs={phienHop?.khungNoiDungs}
              khungNoiDungId={khungNoiDungId}
              onSelectNoiDung={handleSelectNoiDung}
            />

            {/* Document Section */}
            {Document}
          </Box>

          {/* VanDe Section */}
          <Box
            sx={{
              display: "grid",
              // gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            {/* <Box>{renderDangKy}</Box> */}
            <Box>{renderVanDe}</Box>
          </Box>
        </Box>
      </div>
    </Fragment>
  );
});
export default Index;
